import { Link } from "react-router-dom";

import { useAuth } from "@/lib/auth";
import { cn } from "@/lib/utils";

type PackageType = string;

type Props = {
  package: PackageType;
  className?: string;
  children: React.ReactNode;
};

export function BriefEntryLink({ package: pkg, className, children }: Props) {
  const { session, status } = useAuth();
  const target = `/brief/new?package=${encodeURIComponent(pkg)}`;
  const to =
    status === "loading"
      ? "/signin"
      : session
        ? target
        : `/signin?callbackUrl=${encodeURIComponent(target)}`;

  return (
    <Link to={to} className={cn(className)}>
      {children}
    </Link>
  );
}
